/////////////////////Project//////////////////////////////

export const createProject = `mutation createProject(
    $project_name: String!,
    $project_description: String,
    $project_keyword: [ProjectKeywordInput],
    $reference_methodUrl: [String],
    $project_source: String,
    $research_area: String,
    $video_url: String) 
    {
        createProject(
            input:{ 
                project_name: $project_name,
                project_description: $project_description,
                project_keyword: $project_keyword,
                reference_methodUrl: $reference_methodUrl,
                project_source: $project_source,
                research_area: $research_area,
                video_url: $video_url
        }) {
            project_id
            project_name
            user_id
        }
    }
`

export const updateProject = `mutation updateProject(
    $project_id: String!,
    $project_name: String,
    $project_description: String,
    $project_keyword: [ProjectKeywordInput],
    $reference_methodUrl: [String],
    $project_source: String,
    $research_area: String,
    $video_url: String) 
    {
        updateProject(
            input:{ 
                project_id: $project_id,
                project_name: $project_name,
                project_description: $project_description,
                project_keyword: $project_keyword,
                reference_methodUrl: $reference_methodUrl,
                project_source: $project_source,
                research_area: $research_area,
                video_url: $video_url
        }) {
            project_id
            project_name
            user_id
            project_description
            project_keyword {
                label
                value
            }
            research_area
            reference_methodUrl
            role_level
            project_source
            created_date
            last_modified
            video_url
        }
    }
`

export const deleteProject = (project_id) => `mutation {
    deleteProject (project_id:"${project_id}")
    {
        project_id
        project_name
        project_source
        research_area
        role_level
        user_id
        video_url
        amount_comment
        created_date
        last_modified
        project_description
        reference_methodUrl
        add_to_my_project
        project_likes
        project_keyword {
            label
            value
        }
        owner
        project_view
    }
}`

export const addLikeProject = (project_id) => `mutation {
    addLikeProject (project_id:"${project_id}")
    {
        project_id
        project_name
        project_source
        research_area
        role_level
        user_id
        video_url
        amount_comment
        created_date
        last_modified
        project_description
        reference_methodUrl
        add_to_my_project
        project_likes
        project_keyword {
            label
            value
        }
        owner
        project_view
    }
}`

export const unLikeProject = (project_id) => `mutation {
    unLikeProject (project_id:"${project_id}")
    {
        project_id
        project_name
        project_source
        research_area
        role_level
        user_id
        video_url
        amount_comment
        created_date
        last_modified
        project_description
        reference_methodUrl
        add_to_my_project
        project_likes
        project_keyword {
            label
            value
        }
        owner
        project_view
    }
}`

export const addToMyProject = (project_id) => `mutation {
    addToMyProject (project_id:"${project_id}")
    {
        project_id
        project_name
        project_source
        research_area
        role_level
        user_id
        video_url
        amount_comment
        created_date
        last_modified
        project_description
        reference_methodUrl
        add_to_my_project
        project_likes
        project_keyword {
            label
            value
        }
        owner
        project_view
        reference_add_to_my_project {
            project_id
            user_id
        }
    }
}`
export const putReportFile = ({
	product_name,
	price,
	project_id,
	full_report_url,
	preview_report_url
}) => `mutation {
    createReport (
        input:{
            product_name:"${product_name}",
            price:${price},
            project_id:"${project_id}",
            full_report_url:"${full_report_url}",
            preview_report_url:"${preview_report_url}"
        }
    ){
        product_id
        product_name
        product_type
        price
        preview_report_url
        full_report_url
        project_id
        last_modified
        created_date
        user_id
    }
}`
export const uploadFile = ({
	access_level,
	body,
	filename,
	path,
	mime
}) => `mutation {
    uploadFile (
        input:{
            access_level:"${access_level}",
            body:"${body}",
            filename:"${filename}",
            path:"${path}",
            mime:"${mime}"
        }
    ){
        statusCode
        body
    }
}`
export const createSignS3 = ({
	access_level,
	filename,
	path,
	mime
}) => `mutation {
    createSignS3 (
        input:{
            access_level:"${access_level}",
            filename:"${filename}",
            path:"${path}",
            mime:"${mime}"
        }
    ){
        statusCode
        body
    }
}`

export const deleteReportFile = (product_id) => `mutation {
    deleteReport (product_id:"${product_id}")
    {
        product_id
        product_name
        product_type
        price
        preview_report_url
        full_report_url
        project_id
        last_modified
        created_date
        user_id
    }
}`
/////////////////////User//////////////////////////////

export const trackLogin = (user_location) => `mutation {
    trackLogin (user_location:"${user_location}")
    {
        data{
            created_date
            history_action
            history_detail
            history_id
            subject_id
            target_action
        }
        next_token{
            created_date
            history_action
            subject_id
          }
    }
}`

export const createUser = `mutation createUser(
    $email: String!,
	$provider: String!,
	$first_name: String!,
    $last_name: String!,
	$phone_number: String,
    $profile_picture: String,
	$user_address: String,
	$user_company: String,
	$occupation: String,
	$research_field: String,
	$department: String,
    $country: String,
    $ip_country: String,
    $ip_city: String,
    $ip_country_code: String,
    $ip_continent: String,
    $ip_query: String,
    $accepted_news: Boolean) 
    {
        createUser(
            input:{ 
                email: $email,
                phone_number: $phone_number,
                first_name: $first_name,
                last_name: $last_name,
                profile_picture: $profile_picture,
                user_address: $user_address,
                user_company: $user_company,
                provider: $provider,
                occupation: $occupation,
                research_field: $research_field,
                department: $department,
                country: $country,
                ip_country: $ip_country
                ip_city: $ip_city
                ip_country_code: $ip_country_code
                ip_continent: $ip_continent
                ip_query: $ip_query
                accepted_news: $accepted_news
        }) {
            user_id
            first_name
            last_name
            user_address
            user_company
            provider
            following
            follower
            email
            created_date
            last_modified
            library_list
            phone_number
            profile_picture
            occupation
            research_field
            department
            country
            ip_country
            favorite_project
            accepted_news
        }
    }
`

export const updateUserLatestLogin = `mutation {
    updateUser{
        email
        latest_login
    }
}`
export const updateUser = `mutation updateUser(
    $email: String,
	$phone_number: String,
	$first_name: String,
	$last_name: String,
	$user_address: String,
	$user_company: String,
	$occupation: String,
	$research_field: String,
    $department: String,
    $profile_picture: String,
    $country: String,
    $ip_country: String,
    $ip_city: String,
    $ip_country_code: String,
    $ip_continent: String,
    $ip_query: String,
    $accepted_news: Boolean
    ) 
    {
        updateUser(
            input:{ 
                email: $email,
                phone_number: $phone_number,
                first_name: $first_name,
                last_name: $last_name,
                user_address: $user_address,
                user_company: $user_company,
                occupation: $occupation,
                research_field: $research_field,
                department: $department,
                profile_picture: $profile_picture,
                country: $country
                ip_country: $ip_country
                ip_city: $ip_city
                ip_country_code: $ip_country_code
                ip_continent: $ip_continent
                ip_query: $ip_query
                accepted_news: $accepted_news
        }) {
            user_id
            first_name
            last_name
            user_address
            user_company
            provider
            following
            follower
            email
            created_date
            last_modified
            library_list
            phone_number
            profile_picture
            occupation
            research_field
            department
            country
            ip_country
            favorite_project
            accepted_news
        }
    }
`
export const writeRating = ({
	rating_type,
	project_id,
	rating_comment,
	rating_score,
	mma_known_source
}) => {
	if (rating_comment) {
		return `mutation {
                writeRating (
                    input:{
                        rating_type: "${rating_type}",
                        project_id: "${project_id}",
                        rating_comment: "${rating_comment}",
                        rating_score:${rating_score},
                        mma_known_source:"${mma_known_source}"
                    }
                ){
                    statusCode
                    body
                }
            }`
	}
	return `mutation {
            writeRating (
                input:{
                    rating_type: "${rating_type}",
                    project_id: "${project_id}",
                    rating_comment: ${rating_comment},
                    rating_score:${rating_score},
                    mma_known_source:"${mma_known_source}"
                }
            ){
                statusCode
                body
            }
        }`
}
export const updateRating = ({
	rating_id,
	rating_type,
	rating_comment,
	rating_score,
	mma_known_source
}) => {
	if (rating_comment) {
		return `mutation {
                updateRating (
                    input:{
                        rating_id: "${rating_id}",
                        rating_type: "${rating_type}",
                        rating_comment: "${rating_comment}",
                        rating_score:${rating_score},
                        mma_known_source:"${mma_known_source}"
                    }
                ){
                    statusCode
                    body
                }
            }`
	}
	return `mutation {
        updateRating (
            input:{
                rating_id: "${rating_id}",
                rating_type: "${rating_type}",
                rating_comment: ${rating_comment},
                rating_score:${rating_score},
                mma_known_source:"${mma_known_source}"
            }
        ){
            statusCode
            body
        }
    }`
}

export const addfavoriteProject = (project_id, added) => `mutation {
    addfavoriteProject (project_id:"${project_id}",added:${added})
    {
        user_id
        first_name
        last_name
        user_address
        user_company
        provider
        following
        follower
        email
        created_date
        last_modified
        library_list
        phone_number
        profile_picture
        occupation
        research_field
        department
        country
        ip_country
        favorite_project
        accepted_news
    }
}`

export const followUser = (user_id, follow) => `mutation {
    followUser (user_id:"${user_id}",follow:${follow})
    {
        user_id
        first_name
        last_name
        user_address
        user_company
        provider
        following
        follower
        email
        created_date
        last_modified
        library_list
        phone_number
        profile_picture
        occupation
        research_field
        department
        country
        ip_country
        favorite_project
    }
}`

export const sendEmail = `mutation sendEmail(
    $source_email: String
    $destination_email: String
    $destination_user_id: String
    $message: String
    $subject_email: String) 
    {
        sendEmail(
            input:{ 
                source_email: $source_email,
                destination_email: $destination_email,
                destination_user_id: $destination_user_id,
                message: $message,
                subject_email: $subject_email
        }) {
            communicate_id
            source_email
            source_user_id
            destination_email
            destination_user_id
            message
            subject_email
        }
    }
`

/////////////////////Community//////////////////////////////

export const createComment = `mutation createComment(
    $project_id: String!,
	$content: String!) 
    {
        createComment(
            input:{ 
                project_id: $project_id,
                content: $content
        }) {
            user_id
            comment_id
            content
            created_date
            project_id
            last_modified
        }
    }
`

export const updateComment = `mutation updateComment(
    $project_id: String!,
    $comment_id: String!,
	$content: String!) 
    {
        updateComment(
            input:{ 
                project_id: $project_id,
                comment_id: $comment_id,
                content: $content
        }) {
            user_id
            comment_id
            content
            created_date
            project_id
            last_modified
        }
    }
`

export const deleteComment = `mutation deleteComment(
    $comment_id:String!,
    $project_id:String!)
    {
        deleteComment (
            input:{
                comment_id:$comment_id,
                project_id:$project_id
            }
        ){
            user_id
            comment_id
            content
            created_date
            project_id
            last_modified
        }
    }
`

/////////////////////Assignment//////////////////////////////

export const createAssignment = `mutation createAssignment(
    $project_id: String!,
    $assignment_name: String,
    $assignment_description: String,
    $params: ModelInput,
    $software: String,
    $selected_software: [String],
    ) 
    {
        createAssignment(
            input:{ 
                project_id: $project_id,
                assignment_name: $assignment_name,
                assignment_description: $assignment_description,
                params: $params,
                software: $software,
                selected_software: $selected_software
        }) {
            project_id
            assignment_name
            assignment_description
            assignment_id
            params { 
                fixed_model {class,values,label,typeOfCal}
                random_model {class,values,label,typeOfCal}
                residual {class,values,label,typeOfCal}
                y_variate {class,values,label,typeOfCal}
            }
            user_id
            created_date
            last_modified
            selected_software
        }
    }
`

export const deleteAssignment = `mutation deleteAssignment(
    $assignment_id: String!,
    $project_id: String!) 
    {
        deleteAssignment(
            input:{ 
                assignment_id: $assignment_id,
                project_id: $project_id
        }) {
            project_id
            assignment_name
            assignment_description
            assignment_id
            params { 
                fixed_model {class,values,label,typeOfCal}
                random_model {class,values,label,typeOfCal}
                residual {class,values,label,typeOfCal}
                y_variate {class,values,label,typeOfCal}
            }
            user_id
            created_date
            last_modified
        }
    }
`

export const updateAssignment = `mutation updateAssignment(
    $assignment_id: String!,
    $project_id: String!,
    $assignment_name: String,
    $assignment_description: String,
    $params: ModelInput,
    $software: String,
    $selected_software: [String]) 
    {
        updateAssignment(
            input:{ 
                assignment_id: $assignment_id,
                project_id: $project_id,
                assignment_name: $assignment_name,
                assignment_description: $assignment_description,
                params: $params,
                selected_software: $selected_software,
                software: $software
        }) {
            project_id
            assignment_name
            assignment_description
            assignment_id
            params { 
                fixed_model {class,values,label,typeOfCal}
                random_model {class,values,label,typeOfCal}
                residual {class,values,label,typeOfCal}
                y_variate {class,values,label,typeOfCal}
            }
            user_id
            created_date
            last_modified
            selected_software
        }
    }
`

export const createSG = `mutation createSG(
    $project_id: String!,
    $assignment_id: String!,
    $assignment_name: String,
    $assignment_description: String,
    $params: ModelInput,
    $software: String) 
    {
        createSG(
            input:{ 
                project_id: $project_id,
                assignment_id: $assignment_id,
                assignment_name: $assignment_name,
                assignment_description: $assignment_description,
                params: $params,
                software: $software
        }) {
            result{
                scriptId
                script
                summarized_script
            }
            message
        }
    }
`

export const addScriptAssigment = `mutation addScriptAssigment(
    $assignment_id: String!,
    $name: String!,
    $script: String!,
    $path: String) 
    {
        addScriptAssigment(
            input:{
                assignment_id: $assignment_id,
                name: $name,
                script: $script,
                path: $path
        }) {
            name
            script
            path
            script_id
        }
    }
`

export const updateScriptAssignment = `mutation updateScriptAssignment(
    $assignment_id: String!,
    $script_id: String!,
    $name: String,
    $script: String,
    $path: String)
    {
        updateScriptAssignment(
            input:{
                assignment_id: $assignment_id,
                script_id: $script_id,
                name: $name,
                script: $script,
                path: $path
        }) {
            name
            script
            path
            script_id
        }
    }
`

export const deleteScriptAssignment = `mutation deleteScriptAssignment(
    $assignment_id: String!,
    $script_id: String!)
    {
        deleteScriptAssignment(
            input:{
                assignment_id: $assignment_id,
                script_id: $script_id,
        }) {
            name
            script
            path
            script_id
        }
    }
`

//Notification

export const updateSeenNotification = (notification_id) => `mutation {
    updateSeenNotification (notification_id:"${notification_id}")
    {
        notification_title
        notification_type
        notification_body
        date_time
        notification_id
        user_id
        from
        seen
    }
}`

//Subsctibe new

export const addEmailSubscribe = (email) => `mutation {
    addEmailSubscribe (email:"${email}")
    {
        email
        register
        email_subscribe_id
        date_time
    }
}`
